import * as i0 from '@angular/core';
import { Injectable, inject, Optional, Inject, NgModule } from '@angular/core';
import * as i1 from 'angular-google-tag-manager';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import * as i1$1 from '@digipay/ngx-hybrid-service';
import * as i2 from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
let GtmService = /*#__PURE__*/(() => {
  class GtmService {
    constructor(gtmService) {
      this.gtmService = gtmService;
    }
    init() {
      this.gtmService.addGtmToDom();
    }
    sendEvent(eventData) {
      this.gtmService.pushTag(eventData);
    }
    static {
      this.ɵfac = function GtmService_Factory(t) {
        return new (t || GtmService)(i0.ɵɵinject(i1.GoogleTagManagerService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GtmService,
        factory: GtmService.ɵfac
      });
    }
  }
  return GtmService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IntrackService = /*#__PURE__*/(() => {
  class IntrackService {
    constructor(ngxHybridService, httpClient) {
      this.ngxHybridService = ngxHybridService;
      this.httpClient = httpClient;
      this.platform = '';
      this.webPushConfig = {
        subscriptionStyle: {
          subscriptionTheme: 0
        }
      };
      this.setPlatform();
    }
    init(config) {
      const intrackConfig = {
        ...config
      };
      if (this.ngxHybridService.isHybrid()) {
        intrackConfig.webView = true;
        if (this.ngxHybridService.isAndroidHybrid() && config.android_auth_key) {
          intrackConfig.android_auth_key = config.android_auth_key;
        }
        if (this.ngxHybridService.isIosHybrid() && config.ios_auth_key) {
          intrackConfig.ios_auth_key = config.ios_auth_key;
        }
      }
      // Add default sw_path if not provided
      if (!intrackConfig.sw_path) {
        intrackConfig.sw_path = '/ngsw-worker.js';
      }
      (function addConfig(appWindow, document, tagName, jsUrl, intkName, config, referenceNode) {
        const onload = appWindow['InTrack'] = appWindow['InTrack'] || {};
        appWindow[intkName] = appWindow[intkName] || function addItem() {
          (onload.q = onload.q || []).push(arguments);
        };
        const script = document.createElement(tagName);
        script.async = true;
        script.src = jsUrl;
        script.onload = function addOnload() {
          onload.init(config);
        };
        const element = document.getElementsByTagName(tagName)[0];
        element.parentNode?.insertBefore(script, referenceNode);
      })(window, document, 'script', '//static1.intrack.ir/api/web/download/sdk/v1/inTrack.min.js?v=00', 'Intk', intrackConfig);
    }
    login(userId) {
      try {
        if (!this.isIntrackExist()) {
          return;
        }
        const userDetail = {
          userId
        };
        window.Intk('login', userDetail);
      } catch (e) {
        console.error('INTRACK_ERROR', e);
      }
    }
    logout() {
      try {
        if (!this.isIntrackExist()) {
          return;
        }
        window.Intk('logout');
      } catch (e) {
        console.error('INTRACK_ERROR', e);
      }
    }
    initOnSiteMessaging(config) {
      try {
        if (!this.isIntrackExist()) {
          return;
        }
        window.Intk('initOnSiteMessaging', config || this.onSiteConfig);
      } catch (e) {
        console.error('INTRACK_ERROR', e);
      }
    }
    initWebPush(config) {
      try {
        if (!this.isIntrackExist()) {
          return;
        }
        window.Intk('InitWebPush', config || this.webPushConfig);
      } catch (e) {
        console.error('INTRACK_ERROR', e);
      }
    }
    sendEvent(eventData) {
      try {
        if (!this.isIntrackExist()) {
          return;
        }
        window.Intk('sendEvent', {
          eventName: eventData.eventName,
          eventData: Object.assign(eventData.eventData || {}, {
            platform: this.platform
          })
        });
      } catch (e) {
        console.error('INTRACK_ERROR', e);
      }
    }
    setPlatform() {
      this.platform = this.ngxHybridService.isAndroidHybrid() ? 'Hybrid Android' : this.ngxHybridService.isIosHybrid() ? 'Hybrid IOS' : 'PWA';
    }
    isIntrackExist() {
      return !!(window.Intk && typeof window.Intk === 'function');
    }
    customIntrackEventRestApi(restApiData, eventData) {
      const path = this.checkHostAddress(restApiData.host) + 'api/sdk/accounts/' + restApiData.licenseCode + '/events';
      const options = {
        headers: {
          'Authorization': 'Bearer ' + restApiData.apiKey,
          'Content-Type': 'application/json'
        }
      };
      return this.httpClient.post(path, eventData, options);
    }
    checkHostAddress(hostPath) {
      if (hostPath.slice(-1) !== '/') {
        return hostPath + '/';
      }
      return hostPath;
    }
    static {
      this.ɵfac = function IntrackService_Factory(t) {
        return new (t || IntrackService)(i0.ɵɵinject(i1$1.NgxHybridService), i0.ɵɵinject(i2.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IntrackService,
        factory: IntrackService.ɵfac
      });
    }
  }
  return IntrackService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxEventTrackerService = /*#__PURE__*/(() => {
  class NgxEventTrackerService {
    constructor(providedConfig) {
      this.providedConfig = providedConfig;
      this.config = {
        platforms: {
          gtm: {
            enabled: false
          },
          intrack: {
            enabled: false
          }
        }
      };
      this.lastUrlAfterRedirect = null;
      this.regex = /[^?]*/;
      this.environment = 'development';
      this.gtmService = inject(GtmService, {
        optional: true
      });
      this.intrackService = inject(IntrackService, {
        optional: true
      });
      this.router = inject(Router, {
        optional: true
      });
      this.activatedRoute = inject(ActivatedRoute, {
        optional: true
      });
      if (providedConfig) {
        this.config = {
          ...this.config,
          ...providedConfig
        };
        if (providedConfig.environment?.env) {
          this.environment = providedConfig.environment.env;
        }
      }
    }
    /**
     * Initialize the event tracking services
     * @param config Configuration for all tracking platforms
     */
    init(config) {
      if (config) {
        this.config = {
          ...this.config,
          ...config
        };
        if (config.environment?.env) {
          this.environment = config.environment.env;
        }
      }
      // Initialize GTM if enabled
      if (this.config.platforms?.gtm?.enabled && this.gtmService && (this.config?.platforms?.gtm?.id || this.config?.environment?.gtm_id)) {
        this.gtmService.init();
      }
      // Initialize Intrack if enabled
      if (this.config.platforms?.intrack?.enabled && this.intrackService) {
        // Use either platforms.intrack.config or environment.intrack_config
        const intrackConfig = this.config.platforms.intrack.config || this.config.environment?.intrack_config;
        if (intrackConfig) {
          this.intrackService.init(intrackConfig);
        }
      }
      // Setup router events for GTM page tracking
      this.setupRouterEvents();
    }
    /**
     * Send an event to all or specific platforms
     * @param eventData Event data to send
     * @param options Options for sending the event
     */
    sendEvent(eventData, options) {
      const platformsToUse = options?.platforms || this.getEnabledPlatforms();
      platformsToUse.forEach(platform => {
        switch (platform) {
          case 'gtm':
            if (this.gtmService && this.config.platforms?.gtm?.enabled) {
              // If data is in Intrack format, convert it to GTM format
              if ('eventName' in eventData) {
                const intrackEvent = eventData;
                const gtmEvent = {
                  event: intrackEvent.eventName,
                  ...intrackEvent.eventData
                };
                this.gtmService.sendEvent(gtmEvent);
              } else {
                this.gtmService.sendEvent(eventData);
              }
            }
            break;
          case 'intrack':
            if (this.intrackService && this.config.platforms?.intrack?.enabled) {
              // Convert GTM format to Intrack format if necessary
              if ('event' in eventData) {
                const gtmEvent = eventData;
                const intrackEvent = {
                  eventName: gtmEvent.event,
                  eventData: {
                    ...gtmEvent
                  }
                };
                delete intrackEvent.eventData['event'];
                this.intrackService.sendEvent(intrackEvent);
              } else {
                this.intrackService.sendEvent(eventData);
              }
            }
            break;
        }
      });
    }
    /**
     * Login user in Intrack
     * @param userId User identifier
     */
    loginIntrack(userId) {
      if (this.intrackService && this.config.platforms?.intrack?.enabled) {
        this.intrackService.login(userId);
      }
    }
    /**
     * Logout user from Intrack
     */
    logoutIntrack() {
      if (this.intrackService && this.config.platforms?.intrack?.enabled) {
        this.intrackService.logout();
      }
    }
    /**
     * Initialize Intrack on-site messaging
     * @param config On-site messaging configuration
     */
    initIntrackOnSiteMessaging(config) {
      if (this.intrackService && this.config.platforms?.intrack?.enabled) {
        this.intrackService.initOnSiteMessaging(config);
      }
    }
    /**
     * Initialize Intrack web push notifications
     * @param config Web push configuration
     */
    initIntrackWebPush(config) {
      if (this.intrackService && this.config.platforms?.intrack?.enabled) {
        this.intrackService.initWebPush(config);
      }
    }
    /**
     * Setup router events for GTM page tracking
     */
    setupRouterEvents() {
      if (!this.router || !this.activatedRoute || !this.gtmService || !this.config.platforms?.gtm?.enabled) {
        return;
      }
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
        if (event instanceof NavigationEnd) {
          // Check if query parameters exist in the URL
          const urlTree = this.router.parseUrl(event.urlAfterRedirects);
          if (urlTree.queryParams && Object.keys(urlTree.queryParams).length > 0) {
            this.saveCustomQueryParam();
          }
          // Prevent sending duplicate page events to GTM after changing the query parameters in the dropdown.
          const shouldSendEvent = this.environment === 'production' || this.environment === 'staging';
          if (shouldSendEvent && this.lastUrlAfterRedirect?.match(this.regex)[0] !== this.router.url.match(this.regex)[0]) {
            this.gtmService.sendEvent({
              event: 'page_event',
              page_url: event.urlAfterRedirects,
              old_page: this.lastUrlAfterRedirect ?? '/'
            });
            this.lastUrlAfterRedirect = this.router.url;
          }
        }
      });
    }
    /**
     * Save custom query parameters
     */
    saveCustomQueryParam() {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: {
          ...this.activatedRoute.snapshot.queryParams
        },
        queryParamsHandling: 'merge',
        replaceUrl: true,
        fragment: this.activatedRoute.snapshot.fragment
      });
    }
    /**
     * Get list of enabled platforms
     */
    getEnabledPlatforms() {
      const platforms = [];
      if (this.config.platforms?.gtm?.enabled) {
        platforms.push('gtm');
      }
      if (this.config.platforms?.intrack?.enabled) {
        platforms.push('intrack');
      }
      return platforms;
    }
    static {
      this.ɵfac = function NgxEventTrackerService_Factory(t) {
        return new (t || NgxEventTrackerService)(i0.ɵɵinject('EVENT_TRACKER_CONFIG', 8));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxEventTrackerService,
        factory: NgxEventTrackerService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxEventTrackerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxEventTrackerModule = /*#__PURE__*/(() => {
  class NgxEventTrackerModule {
    static forRoot(config) {
      return {
        ngModule: NgxEventTrackerModule,
        providers: [
        // Provide GTM ID to GoogleTagManagerModule
        {
          provide: 'googleTagManagerId',
          useValue: config?.platforms?.gtm?.id || config?.environment?.gtm_id || ''
        }, {
          provide: 'EVENT_TRACKER_CONFIG',
          useValue: config || {}
        }, GtmService, IntrackService, NgxEventTrackerService]
      };
    }
    static {
      this.ɵfac = function NgxEventTrackerModule_Factory(t) {
        return new (t || NgxEventTrackerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxEventTrackerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [GtmService, IntrackService, NgxEventTrackerService],
        imports: [GoogleTagManagerModule]
      });
    }
  }
  return NgxEventTrackerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-event
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GtmService, IntrackService, NgxEventTrackerModule, NgxEventTrackerService };
